import React from 'react'
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../../redux/store';
import { MonthObj, getOrders, unselectMonth } from '../../redux/orderSlice';
import { monthNames } from '../../names';
import { getOfficeData } from '../../redux/officeSlice';

export const OfficeSwitcher = ({months}) => {

    const dispatch = useDispatch();

    const selectMonthHandler = (month) => {
        dispatch(getOfficeData({month}));
    };
    
    return (
        <div className="month-switcher">
            {months.map((m) => (
                <button
                    className={`button dark-theme-bg0 ${m.active ? 'active' : ''} ${m.loaded ? 'loaded' : ''}`}
                    onClick={(e) => selectMonthHandler(m.month)}
                    key={m.month}>
                    {monthNames[+m.month.split('-')[1] - 1]} {m.month.split('-')[0]}
                </button>
            ))}
        </div>
    );
}
